import { DiscountPlanMaster, CategoryMap, IndustryMap, Category, VendorRole } from "../types/type";


// const CATEGORY: CategoryMap = {
//     "1": { name: "特別高圧", color: "#007bff" },
//     "2": { name: "高圧電力", color: "#007bff" },
//     "3": { name: "従量電灯", color: "#eb9e68" },
//     "4": { name: "低圧電力", color: "#eb9e68" },
// };
export const VENDOR_ROLES: VendorRole[] = [
    // { id: '2', role: "vendor_manager", name: "責任者(部署内の責任者)" },
    { id: '5', role: "vendor_employee", name: "一般(入札・閲覧のみ)" },
    { id: '3', role: "vendor_admin", name: "管理者" },

];

export const CATEGORY: CategoryMap = {
    "1": { name: "特別高圧", color: "#007bff" },
    "2": { name: "高圧電力", color: "#007bff" },
    "3": { name: "低圧電力", color: "#eb9e68" },
    "4": { name: "従量電灯", color: "#eb9e68" },
};

export const DISCOUNT_PLAN_UNIT = {
    'A': '契約電力',
    'B': '基本料金（力率前）',
    'C': '基本料金（力率後）',
    'D': '使用料金',
    'E': '燃料調整費',
    'F': '総額（燃調費,再エネ賦課金を除く）',
    'G': '蓄熱対象電力量',
    'H': '電化厨房対象電力量',
    'I': '夏期休日対象電力量',
};

export const INDUSTRY_ENUM: IndustryMap = {
    'AGRICULTURE_FORESTRY': '農業，林業',
    'FISHERIES': '漁業',
    'MINING': '鉱業，採石業，砂利採取業',
    'CONSTRUCTION': '建設業',
    'MANUFACTURING': '製造業',
    'ELECTRICAL_GAS': '電気・ガス・熱供給・水道業',
    'INFORMATION_COMMUNICATION': '情報通信業',
    'TRANSPORTATION': '運輸業，郵便業',
    'WHOLESALE_RETAIL': '卸売業，小売業',
    'FINANCE_INSURANCE': '金融業，保険業',
    'REAL_ESTATE': '不動産業，物品賃貸業',
    'ACADEMIC_RESEARCH': '学術研究，専門・技術サービス業',
    'ACCOMMODATION_FOOD': '宿泊業，飲食サービス業',
    'LIVING_RELATED_ENTERTAINMENT': '生活関連サービス業，娯楽業',
    'EDUCATION': '教育，学習支援業',
    'MEDICAL_WELFARE': '医療，福祉',
    'COMPOUND_SERVICE': '複合サービス事業',
    'SERVICE_OTHER': 'サービス業（他に分類されないもの）',
    'PUBLIC_SERVICE': '公務(他に分類されるものを除く）',
    'UNCLASSIFIED': '分類不能の産業'
};

export const INDUSTRY_ENUM_CATEGORY: { [key: string]: string } = {
    'A': 'AGRICULTURE_FORESTRY',
    'B': 'FISHERIES',
    'C': 'MINING',
    'D': 'CONSTRUCTION',
    'E': 'MANUFACTURING',
    'F': 'ELECTRICAL_GAS',
    'G': 'INFORMATION_COMMUNICATION',
    'H': 'TRANSPORTATION',
    'I': 'WHOLESALE_RETAIL',
    'J': 'FINANCE_INSURANCE',
    'K': 'REAL_ESTATE',
    'L': 'ACADEMIC_RESEARCH',
    'M': 'ACCOMMODATION_FOOD',
    'N': 'LIVING_RELATED_ENTERTAINMENT',
    'O': 'EDUCATION',
    'P': 'MEDICAL_WELFARE',
    'Q': 'COMPOUND_SERVICE',
    'R': 'SERVICE_OTHER',
    'S': 'PUBLIC_SERVICE',
    'T': 'UNCLASSIFIED',
};

export const DISCOUNT_PLAN = {
    'CONTRACT_RENEWAL_DISCOUNT': '契約継続割引',
    'LONGTERM_CONTRACT_DISCOUNT': '長期契約割引',
    'BASIC_RATE_DISCOUNT': '基本料金割引',
    'CORPORATE_SPECIAL_DISCOUNT': '法人特別割引',
    'LARGE_DISCOUNT_AMOUNT': '大口割引額',
    'OTHER_DISCOUNT_MENU': 'その他割引ﾒﾆｭｰ',
    'HEAT_STORAGE_ADJUSTMENT_CONTRACT': '蓄熱調整契約(蓄熱調整割引）',
    'ELECTRIFIED_KITCHEN_CONTRACT_DISCOUNT': '電化厨房契約割引',
    'ALL_ELECTRIFICATION': 'オール電化',
    'SUMMER_HOLIDAY_DISCOUNT': '夏季休日割引',
    'OTHER': 'その他'
};
export const DISCOUNT_PLAN_MASTER: DiscountPlanMaster = {
    1: [
        {
            type: 'LONGTERM_CONTRACT_DISCOUNT',
            target: 'B',
            value: 0,
            unit: '%',
        },
        {
            type: 'BASIC_RATE_DISCOUNT',
            target: 'A',
            value: 0,
            unit: '円',
        },
        {
            type: 'HEAT_STORAGE_ADJUSTMENT_CONTRACT',
            target: 'G',
            value: 0,
            unit: '円',
        },
        {
            type: 'ELECTRIFIED_KITCHEN_CONTRACT_DISCOUNT',
            target: 'H',
            value: 0,
            unit: '円',
        },
    ],
    2: [
        {
            type: 'LONGTERM_CONTRACT_DISCOUNT',
            target: 'B',
            value: 0,
            unit: '%',
        },
        {
            type: 'BASIC_RATE_DISCOUNT',
            target: 'A',
            value: 0,
            unit: '円',
        },
        {
            type: 'HEAT_STORAGE_ADJUSTMENT_CONTRACT',
            target: 'G',
            value: 0,
            unit: '円',
        },
        {
            type: 'ELECTRIFIED_KITCHEN_CONTRACT_DISCOUNT',
            target: 'H',
            value: 0,
            unit: '円',
        },
    ],
    3: [
        {
            type: 'OTHER_DISCOUNT_MENU',
            target: 'A',
            value: 0,
            unit: '円',
        },
        {
            type: 'HEAT_STORAGE_ADJUSTMENT_CONTRACT',
            target: 'G',
            value: 0,
            unit: '円',
        },
        {
            type: 'ELECTRIFIED_KITCHEN_CONTRACT_DISCOUNT',
            target: 'H',
            value: 0,
            unit: '円',
        },
        {
            type: 'ALL_ELECTRIFICATION',
            target: 'F',
            value: 0,
            unit: '%',
        },
    ],
    4: [
        {
            type: 'OTHER_DISCOUNT_MENU',
            target: 'C',
            value: 0,
            unit: '%',
        },
        {
            type: 'OTHER_DISCOUNT_MENU',
            target: 'D',
            value: 0,
            unit: '%',
        },
        {
            type: 'HEAT_STORAGE_ADJUSTMENT_CONTRACT',
            target: 'G',
            value: 0,
            unit: '円',
        },
        {
            type: 'ELECTRIFIED_KITCHEN_CONTRACT_DISCOUNT',
            target: 'H',
            value: 0,
            unit: '円',
        },
        {
            type: 'ALL_ELECTRIFICATION',
            target: 'F',
            value: 0,
            unit: '%',
        },
    ],
    5: [
        {
            type: 'CONTRACT_RENEWAL_DISCOUNT',
            target: 'C',
            value: 0,
            unit: '%',
        },
        {
            type: 'LONGTERM_CONTRACT_DISCOUNT',
            target: 'C',
            value: 0,
            unit: '%',
        },
        {
            type: 'CORPORATE_SPECIAL_DISCOUNT',
            target: 'C',
            value: 0,
            unit: '%',
        },
        {
            type: 'CORPORATE_SPECIAL_DISCOUNT',
            target: 'D',
            value: 0,
            unit: '%',
        },
        {
            type: 'LARGE_DISCOUNT_AMOUNT',
            target: 'A',
            value: 0,
            unit: '円',
        },
        {
            type: 'HEAT_STORAGE_ADJUSTMENT_CONTRACT',
            target: 'G',
            value: 0,
            unit: '円',
        },
        {
            type: 'ELECTRIFIED_KITCHEN_CONTRACT_DISCOUNT',
            target: 'H',
            value: 0,
            unit: '円',
        },
        {
            type: 'ALL_ELECTRIFICATION',
            target: 'F',
            value: 0,
            unit: '%',
        },
        {
            type: 'SUMMER_HOLIDAY_DISCOUNT',
            target: 'I',
            value: 0,
            unit: '円',
        },
    ],
    6: [
        {
            type: 'LONGTERM_CONTRACT_DISCOUNT',
            target: 'C',
            value: 0,
            unit: '%',
        },
        {
            type: 'CORPORATE_SPECIAL_DISCOUNT',
            target: 'C',
            value: 0,
            unit: '%',
        },
        {
            type: 'CORPORATE_SPECIAL_DISCOUNT',
            target: 'D',
            value: 0,
            unit: '%',
        },
        {
            type: 'LARGE_DISCOUNT_AMOUNT',
            target: 'C',
            value: 0,
            unit: '%',
        },
        {
            type: 'LARGE_DISCOUNT_AMOUNT',
            target: 'D',
            value: 0,
            unit: '%',
        },
        {
            type: 'HEAT_STORAGE_ADJUSTMENT_CONTRACT',
            target: 'G',
            value: 0,
            unit: '円',
        },
        {
            type: 'ELECTRIFIED_KITCHEN_CONTRACT_DISCOUNT',
            target: 'H',
            value: 0,
            unit: '円',
        },
        {
            type: 'ALL_ELECTRIFICATION',
            target: 'F',
            value: 0,
            unit: '%',
        },
    ],
    7: [
        {
            type: 'LONGTERM_CONTRACT_DISCOUNT',
            target: 'C',
            value: 0,
            unit: '%',
        },
        {
            type: 'LARGE_DISCOUNT_AMOUNT',
            target: 'C',
            value: 0,
            unit: '%',
        },
        {
            type: 'LARGE_DISCOUNT_AMOUNT',
            target: 'D',
            value: 0,
            unit: '%',
        },
        {
            type: 'HEAT_STORAGE_ADJUSTMENT_CONTRACT',
            target: 'G',
            value: 0,
            unit: '円',
        },
        {
            type: 'ELECTRIFIED_KITCHEN_CONTRACT_DISCOUNT',
            target: 'H',
            value: 0,
            unit: '円',
        },
    ],
    8: [
        {
            type: 'LONGTERM_CONTRACT_DISCOUNT',
            target: 'C',
            value: 0,
            unit: '%',
        },
        {
            type: 'HEAT_STORAGE_ADJUSTMENT_CONTRACT',
            target: 'G',
            value: 0,
            unit: '円',
        },
        {
            type: 'ELECTRIFIED_KITCHEN_CONTRACT_DISCOUNT',
            target: 'H',
            value: 0,
            unit: '円',
        },
        {
            type: 'ALL_ELECTRIFICATION',
            target: 'F',
            value: 0,
            unit: '%',
        },
    ],
    9: [
        {
            type: 'LONGTERM_CONTRACT_DISCOUNT',
            target: 'A',
            value: 0,
            unit: '%',
        },
        {
            type: 'LARGE_DISCOUNT_AMOUNT',
            target: 'E',
            value: 0,
            unit: '%',
        },
        {
            type: 'LARGE_DISCOUNT_AMOUNT',
            target: 'F',
            value: 0,
            unit: '%',
        },
        {
            type: 'HEAT_STORAGE_ADJUSTMENT_CONTRACT',
            target: 'G',
            value: 0,
            unit: '円',
        },
        {
            type: 'ELECTRIFIED_KITCHEN_CONTRACT_DISCOUNT',
            target: 'H',
            value: 0,
            unit: '円',
        },
        {
            type: 'ALL_ELECTRIFICATION',
            target: 'F',
            value: 0,
            unit: '%',
        },
    ],
};
